import { useNavigate } from "react-router-dom";

import { useContext, useCallback } from "react";
import { useTranslation } from "react-i18next";

import RequestRow from "./RequestRow";
import { UserContext } from "../../App";

export default function RequestsTable({ requests }) {
    const { i18n,t } = useTranslation();

    const {fields} = useContext(UserContext);

    const navigate = useNavigate();

    const getFormattedTime = useCallback((date) => {
        const dateObject = new Date(date);

        const timeOptions = {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        };

        return dateObject.toLocaleTimeString('en-US', timeOptions);
    }, []);

    const handleNavigate = useCallback((request) => {
        navigate(`/${i18n?.language || 'ar'}/requests/${request?.requestPrettyId}?business=${request.business?._id || ''}`);
    }, [navigate]);

    if(!requests) {
        return;
    }

    return (
        <>
        <div className="pb-[30px]">
            <table className="w-full mt-[30px] border border-darkblue rounded-[8px] border-separate overflow-hidden" cellSpacing={0} dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
                <thead>
                <tr className="border-b-[2px] border-b-grey-50 whitespace-nowrap">
                    <th className="bg-darkBlue text-white leading-[56px] rounded-tr-[8px] ltr:rounded-tr-[0px] ltr:rounded-tl-[8px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">#</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">{t("requestsTable.orderNumber")}</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">{t("requestsTable.orderType")}</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">{t("requestsTable.startDate")}</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">{t("requestsTable.technician")}</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">{t("requestsTable.city")}</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">{t("requestsTable.service")}</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">{t("requestsTable.subServices")}</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">{t("requestsTable.cost")}</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">{t("requestsTable.orderStatus")}</th>
                    <th className="bg-darkBlue text-white leading-[56px] rounded-tl-[8px] ltr:rounded-tl-[0px] ltr:rounded-tr-[8px] text-start px-[15px] text-[16px] font-[500px]"></th>
                </tr>
                </thead>
                <tbody>
                { Array.isArray(requests) && requests?.length > 0 ? requests?.map((request, index) => {
                    return (
                        <RequestRow
                            key={`requests-${index}`}
                            request={request}
                            index={index}
                            length={requests.length}
                            handleNavigate={handleNavigate}
                            fields={fields}
                            getFormattedTime={getFormattedTime}
                        />
                    )
                })
                :   <tr>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap w-[52px] cursor-pointer rounded-br-[8px] text-center`} colSpan={11}>{t("requestsTable.noRequests")}</td>
                    </tr>
                }
                </tbody>
            </table>
        </div>
        </>
    )
}

